import { CHANGE_IMPORT_PAGE } from '../actions/query';

export default function (state = {}, action) {
  switch (action.type) {
  case CHANGE_IMPORT_PAGE:
    return {
      ...state,
      importPage: action.page
    };
  default:
    return state;
  }
}
